import React, { useMemo } from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import { getAuthProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";
import { LoadingFallback } from "../Components/Common/LoadingFallback";

const Index = () => {
  const user = useSelector((state) => state.Login.user); // ✅ Track login state

  // ✅ Memoize auth routes to re-run when user changes
  const authRoutes = useMemo(() => {
    return getAuthProtectedRoutes(); // This reads latest localStorage
  }, [user]); // rerun when login state updates

  return (
    <React.Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public Routes */}
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
            />
          ))}
        </Route>

        {/* Protected Routes */}
        <Route>
          {authRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={idx}
            />
          ))}
        </Route>
      </Routes>
    </React.Suspense>
  );
};

export default Index;
